<template>

	<v-textarea
		
		:label="field.template.name"
		v-model="field.value"
		outlined
		dense
	></v-textarea>
	
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------


export default
{
	name: 'ContentFieldTextArea',

	// ----------------------------------
	//	VUE: Data, properties, etc.
	// ----------------------------------

	props:
	{
		field: { type: Object },
	},

	data: () =>
	({
		value: '',
	}),



	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{
		
		this.field.value = this.field.template.typeProperties.defaultValue;

		if (this.field.data)
		{
			const dataValue = this.field.data;

			if (dataValue)
			{
				this.field.value = dataValue;
			}
			
		}
		
	},

	mounted()
	{
		
	},


	// ----------------------------------------------------
	//
	//  VUE: Methods
	//
	// ----------------------------------------------------

	methods:
	{
		
	}

}

</script>

